import { H2 } from 'app/components/Typography';
import { FlexBox } from '../credential';
import {
  Box,
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import { Searchbar } from '../presets';
import Loading from 'app/components/MatxLoading';
import useInstagram from './hooks/useInstagram';
import { useRecoilValue } from 'recoil';
import { userInstagramStateAtom } from './atom';
import { useEffect } from 'react';
import { useState } from 'react';
import styled from '@emotion/styled';
import InstagramIcon from '@mui/icons-material/Instagram';
import { AddCircle, Delete, KeyOutlined } from '@mui/icons-material';
import AddInstagramDialog from './AddInstagramDialog';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { toast } from 'react-toastify';
import { deleteDoc, doc, getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { LoadingButton } from '@mui/lab';
import UpgradeDialog from '../UpgradePlanDialog';

const StyledTable = styled(Table)(({ theme }) => ({
  whiteSpace: 'pre',
  '& thead': {
    '& tr': { '& th': { paddingLeft: 0, paddingRight: 0 } }
  },
  '& tbody': {
    '& tr': { '& td': { paddingLeft: 0, textTransform: 'capitalize' } }
  }
}));

export const SocialStatus = ({ stat }) => {
  if (!stat || stat === 'live')
    return (
      <span
        style={{
          color: 'white',
          fontWeight: 'bold',
          padding: '5px 10px',
          borderRadius: '5px',
          backgroundColor: 'green'
        }}
      >
        live
      </span>
    );
  else if (stat === 're-auth')
    return (
      <span
        style={{
          color: 'white',
          fontWeight: 'bold',
          padding: '5px 10px',
          borderRadius: '5px',
          backgroundColor: 'red'
        }}
      >
        re-authenticate
      </span>
    );
};

const Instagram = () => {
  const instagrams = useRecoilValue(userInstagramStateAtom);
  const [filteredData, setFilteredData] = useState(null);
  const [search, setSearch] = useState('');
  const [openAddNew, setOpenAddNew] = useState(false);
  const [currentDeletionId, setCurrentDeletionId] = useState(null);
  const { user } = getAuth();
  const [currentReAuthId, setCurrentReAuthId] = useState(null);
  const [upgradeMsg, setUpgradeMsg] = useState(false);

  const handleAddNew = () => {
    if (
      user?.plan?.social?.instagram_acc_limit &&
      instagrams.length >= user?.plan?.social?.instagram_acc_limit
    ) {
      setUpgradeMsg(
        'Instagram account limit reached. You can only add ' +
          user?.plan?.social?.instagram_acc_limit +
          ' Instagram accounts.' +
          ' Please upgrade your plan to add more accounts.'
      );
    } else {
      setOpenAddNew(true);
    }
  };
  const reAuthenticate = async (name, siteId) => {
    setCurrentReAuthId(siteId);
    try {
      const fn = httpsCallable(getFunctions(), 'instagramRequest');
      const res = await fn({ name, siteId, command: 'getOATUHURL' });

      let url = res.data;

      window.open(url, 'popup', 'width=600,height=600');
    } catch (e) {
      console.error(e);
      toast.error('Failed to re-authenticate Instagram account');
    }
    setCurrentReAuthId(null);
  };

  const deleteAccount = async (siteId) => {
    setCurrentDeletionId(siteId);
    try {
      const fn = httpsCallable(getFunctions(), 'instagramRequest');
      await fn({ id: siteId, command: 'delete' });
    } catch (e) {
      console.error(e);
      toast.error('Failed to delete Instagram account');
    }
    setCurrentDeletionId(null);
  };

  useEffect(() => {
    if (!instagrams) return;

    if (search === '') {
      setFilteredData(instagrams);
    } else {
      setFilteredData(
        instagrams.filter((item) => item.name.toLowerCase().includes(search.toLowerCase()))
      );
    }
  }, [search, instagrams]);

  useInstagram();

  return (
    <>
      <AddInstagramDialog open={openAddNew} onClose={() => setOpenAddNew(false)} />
      <UpgradeDialog msg={upgradeMsg} setMsg={setUpgradeMsg} />
      <FlexBox style={{ marginTop: '25px' }}>
        <H2
          style={{
            position: 'absolute',
            top: '-25px',
            left: '12px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }}
        >
          <InstagramIcon fontSize="24px" />
          Instagram Accounts
        </H2>
        <Button
          startIcon={<AddCircle />}
          style={{ position: 'absolute', right: '20px', top: '-25px' }}
          onClick={handleAddNew}
        >
          Add New Account
        </Button>
      </FlexBox>
      <FlexBox>
        <Box
          sx={{ padding: '10px 20px' }}
          md={{ padding: '15px 25px' }}
          style={{ maxWidth: '1500px' }}
        >
          <TableContainer>
            <FlexBox style={{ justifyContent: 'right' }}>
              <Searchbar placeholder={'Search by name'} setSearch={setSearch} />
            </FlexBox>
            <StyledTable>
              <TableHead>
                <TableRow>
                  <TableCell align="left" width="30%">
                    <b>Name</b>
                  </TableCell>
                  <TableCell align="center" width="25%">
                    <b>Status</b>
                  </TableCell>
                  <TableCell align="center" width="45%">
                    <b>Action</b>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {!filteredData && (
                  <TableRow>
                    <TableCell rowSpan={3} colSpan={3}>
                      <Loading />
                    </TableCell>
                  </TableRow>
                )}

                {filteredData && filteredData.length == 0 && (
                  <TableRow>
                    <TableCell rowSpan={3} colSpan={3}>
                      <div
                        style={{
                          width: '100%',
                          height: '50px',
                          marginTop: '20px',
                          textAlign: 'center'
                        }}
                      >
                        <h3>No accounts found</h3>
                      </div>
                    </TableCell>
                  </TableRow>
                )}

                {filteredData &&
                  filteredData.map((item, index) => (
                    <TableRow key={item.id}>
                      <TableCell width="30%">
                        {item.name} ({item.username})
                      </TableCell>
                      <TableCell align="center" width="25%">
                        <SocialStatus stat={item.status} />
                      </TableCell>
                      <TableCell align="left" width="45%">
                        <Stack direction="row" spacing={2} width="100%" justifyContent="center">
                          <LoadingButton
                            loading={currentReAuthId === item.id}
                            color="primary"
                            onClick={() => reAuthenticate(item.name, item.id)}
                            startIcon={<KeyOutlined />}
                          >
                            Re-authenticate
                          </LoadingButton>
                          <LoadingButton
                            color="error"
                            onClick={() => deleteAccount(item.id)}
                            loading={currentDeletionId === item.id}
                          >
                            <Delete />
                          </LoadingButton>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </StyledTable>
          </TableContainer>
        </Box>
      </FlexBox>
    </>
  );
};

export default Instagram;
